import axios from 'axios';
import HoldOn from 'react-hold-on'
import { transactionByTransactionIdSuccess, transactionSuccess } from '../../Reducer/transaction';
import apiUrl from '../../ApiUrl';

//transaction list by student id action
export const getTransactionListByStudentId = (studentId) => async (dispatch) => {
    let options = {
        theme: 'sk-cube-grid',
        message: 'Fetching Transaction List ...',
    }
    try {
        HoldOn.open(options);
        const headers = {
            'user_id': studentId,
            'redirect': 'follow'
        };

        const response = await axios.get(
            `${apiUrl}transfer/fetch-data/user_id`,
            { headers }
        );

        console.log("Response of get transaction list api:- ", response.data);
        dispatch(transactionSuccess(response.data));
        return response.data;

    } catch (error) {
        console.error("Error in get transaction list api:- ", error);
    } finally {
        HoldOn.close();
    }
}

//transaction by transaction id action
export const getTransactionByTransactionId = (transactionId) => async (dispatch) => {
    let options = {
        theme: 'sk-cube-grid',
        message: 'Fetching Transaction List ...',
    }
    try {
        HoldOn.open(options);
        const headers = {
            'trans_id': transactionId,
            'redirect': 'follow'
        };

        const response = await axios.get(
            `${apiUrl}transfer/fetch-data/trans_id`,
            { headers }
        );

        console.log("Response of get transaction by transaction id api:- ", response.data);
        dispatch(transactionByTransactionIdSuccess(response.data));
        return response.data;

    } catch (error) {
        console.error("Error in get transaction by transaction id api:- ", error);
    } finally {
        HoldOn.close();
    }
}